/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Ai_AgentInputs */



/**
* | output |
* | --- |
* | "AI Agent" |
*
* @param {Signup_Compare_Ai_AgentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_ai_agent = /** @type {((inputs?: Signup_Compare_Ai_AgentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Ai_AgentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "de") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "it") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "es") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI Agent")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AI Agent")
	return /** @type {LocalizedString} */ ("AI Agent")
});